import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

import ComCreateUi from "@menu/COM/ComCreateUi";
import layout from "./SN_PRD_RUN_REG_001_CHEM_POP_001.json";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {}
const SN_PRD_RUN_REG_001_CHEM_POP_001 = forwardRef(
  ({}: popupProps, popupRef: React.Ref<any>) => {
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });

    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_RUN_REG_001_CHEM_POP_001"
          );
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(rtn.formData);
          setColums({
            grid1: rtn.grid.grid1,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      searchRef.current?.applyPopupConditions?.({
        cd_item: { fg_item: "M", fg_acct: "004" },
      });
    }, []);

    useImperativeHandle(popupRef, () => ({
      onSearch,
      getOkayData: () => {
        const data = getGridCurrent("grid1").focusedRowNode().data;
        return {
          rtnData: [data],
        };
      },
    }));

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_prd_run_reg_001_chem_pop_001_01",
          params: searchRef.current.getFormdata(),
        };

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0],
        });
      } catch (error: any) {}
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          etcProps: { suppressDragLeaveHidesColumns: true }, // 26.09.07 kdy 태블릿에서 헤더 드래그로 컬럼 사라지는 것 방지
        },
      }),
      [columns, dataSources]
    );

    const search = useMemo(
      () => ({
        data: formData,
        controls: formControlData,
        popupRef,
      }),
      [formData, formControlData]
    );

    const dynamicProps = React.useMemo(
      () => ({
        searchRef,
        search,
        grids,
        gridRefs,
        popupRef,
        onSearch,
      }),
      [formData, formControlData, grids, gridRefs, popupRef]
    );

    //region UI
    return <ComCreateUi dynamicProps={dynamicProps} layoutConfig={layout} />;
  }
);

export default SN_PRD_RUN_REG_001_CHEM_POP_001;
